import { PointsLedgerScreen } from './PointsLedger'
import { PointsTransferInterstitialScreen } from './PointsTransferInterstitial'
import { RewardsScreen } from './RewardsScreenGate'

export const RewardsScreens = {
  Rewards: RewardsScreen,
  PointsLedger: PointsLedgerScreen,
  PointsTransferInterstitial: PointsTransferInterstitialScreen,
}
